import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Discount } from 'src/app/models/discount';
import { ModalDialogType } from '../constants';
import { ProductInfoComponent } from 'src/app/views/products/product-details/product-info/product-info.component';
import { Product } from 'src/app/models/product';
import { ProductDetailsModalComponent } from 'src/app/views/products/product-details-modal/product-details-modal.component';

@Injectable({
  providedIn: 'root'
})
export class PosProductDetailModalService {
  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) {


  }

  async show(product: Product, confirmAction: (product: Product) => any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.modalRef = this.modalService.show(ProductDetailsModalComponent, {
        ignoreBackdropClick: true,
        initialState: { product: product, modal: true }
      });
      this.modalRef.setClass(`modal-dialog modal-lg ${ModalDialogType.PRIMARY}`)
      this.modalRef.content.confirmAction = confirmAction;

      resolve(true);
    })
  }
}
